import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { getOrderMode } from "src/core/drops/utils/inherited-settings";
import { IList } from "src/core/lists/api/lists.api";
import { IDrop } from "src/core/drops/api/drops.api";
import { ProductStatus } from "src/core/products/api/products.api";

export const validateSchedule = (list: IList, drop: IDrop, terminology: ITerminology): { error: boolean; message?: string } => {
  const listLines = list.listLines;
  const orderMode = getOrderMode(drop.groupedSettings);

  if (orderMode && orderMode.allow === "MTO") {
    return {
      error: true,
      message: `${terminology.schedule.plural.text} are not available`
    };
  }

  if (listLines.length === 0) {
    return {
      error: true,
      message: `Add some ${terminology.product.plural.text} first`
    };
  }

  for (const line of listLines) {
    if (line.product) {
      const productCurrentStatus = line.product.currentStatus?.status;

      if (line.product.madeToOrder) {
        return {
          error: true,
          message: `Cannot create a ${terminology.schedule.singular.text} containing made to order ${terminology.product.plural.text}`
        };
      }

      if (productCurrentStatus === ProductStatus.Delisted) {
        return {
          error: true,
          message: `Cannot create a ${terminology.schedule.singular.text} containing ${productCurrentStatus} ${terminology.product.plural.text}`
        };
      }
    }
  }

  return { error: false };
};
